import { ValueLabel } from "@features/ax/shared/ValueLabel";
import { Card } from "@shared/ui/card";

export const InfoCard = ({ meterReadingFormatDetail }: { meterReadingFormatDetail: any }) => {
  const infoItems = [
    {
      label: "Format Name",
      value: meterReadingFormatDetail?.name,
    },
    {
      label: "Utility Service",
      value: meterReadingFormatDetail?.utilityService,
    },
    {
      label: "Data Collection Method",
      value: meterReadingFormatDetail?.dataCollectionMethod?.name || 'NA',
    },
    {
      label: "Resource Type",
      value: meterReadingFormatDetail?.resourceTypeDisplay || "NA",
    },
    {
      label: "Resource Sub Type",
      value: meterReadingFormatDetail?.resourceSubTypeDisplay || "NA",
    },
    {
      label: "Status",
      value: meterReadingFormatDetail?.statusLabel || "NA",
    },
    {
      label: "Created On",
      value: meterReadingFormatDetail?.createdDate || "NA",
    },
    {
      label: "Created By",
      value: meterReadingFormatDetail?.createdUserRemoteName || "—",
    },
    {
      label: "Total Fields",
      value: meterReadingFormatDetail?.totalActiveFields ?? meterReadingFormatDetail?.totalFields ?? 0,
    },
  ];

  return (
    <Card className="p-6 shadow-sm border border-gray-200">
      <div className="flex justify-between items-start mb-8">
        <div className="flex gap-4">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <h2 className="text-xl font-bold text-gray-900">Format Details</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-8 gap-x-4">
        {infoItems.map((item, index) => (
          <ValueLabel
            key={index}
            label={item.label}
            value={item.value}
          />
        ))}
      </div>
    </Card>
  );
};
